const actionType = {
  //auth
  AUTHENTICATE_USER: 'AUTHENTICATE_USER'
}
export default actionType